"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingSlider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Slider_1 = tslib_1.__importDefault(require("@material-ui/core/Slider"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            width: 640,
        },
        margin: {
            height: theme.spacing(3),
        },
    });
});
var PrettoSlider = styles_1.withStyles({
    root: {
        color: "rgb(114, 137, 218)",
        height: 8,
        marginLeft: 5,
        marginRight: 5,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        marginTop: -10,
        marginLeft: -10,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 4px)",
    },
    track: {
        height: 8,
        borderRadius: 4,
    },
    rail: {
        height: 8,
        borderRadius: 4,
    },
})(Slider_1.default);
function SettingSlider() {
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.margin }),
        react_1.default.createElement(PrettoSlider, { valueLabelDisplay: "auto", "aria-label": "pretto slider", defaultValue: 20 })));
}
exports.SettingSlider = SettingSlider;
//# sourceMappingURL=index.js.map